<template>
<div>
	<ul class="title-nav">
		<li v-on:click="routeBack()">
			<div class="back-btn">
				<i class="material-icons md-18">keyboard_arrow_left</i>
			</div> 
			
			<div class="title-label text-uppercase"><i class="fas fa-pen-nib fa-fw"></i> PROVIDER INQUIRY</div>
		</li>
	</ul>
	<div class="mb-4 mt-4">
		<h3 class="mb-2 text-center">
			PROVIDER INQUIRY FORM
		</h3>
		<p>
			Scoutred has a large network of developers working on major projects. Are you a service provider that can help? Join our trusted network and get leads.
		</p>
	</div>
	<form class="" v-on:submit.prevent="submit">
		<div class="form-group">
			<label class="mb-1" for="signUpEmail">Select which categories apply to your service offering</label>
			<span v-for="(category, index) in categories" class="btn btn-default">{{category}}</span>
			<div class="invalid-feedback">
				{{error && error.description}}
	    </div>
		</div>
		<div class="form-group">
			<label class="mb-1" for="signUpEmail">Describe the services you provide</label>
			<textarea class="form-control" id="signUpEmail" aria-describedby="emailHelp" 
				placeholder="Service description" v-model="description"
				v-bind:class="{'is-invalid':error && error.description}"/>
			<div class="invalid-feedback">
				{{error && error.description}}
	    </div>
		</div>
		<div class="form-group">
			<label class="mb-1" for="loginEmail">Email</label>
			<input type="email" class="form-control" id="loginEmail" aria-describedby="emailHelp" 
				placeholder="Enter email" v-model="email"
				v-bind:class="{'is-invalid':error && error.email}"/>
			<div class="invalid-feedback">
				{{error && error.email}}
	    </div>
		</div>
		<div class="form-group">
			<label class="mb-1" for="loginEmail">Phone</label>
			<input type="phone" class="form-control" id="loginEmail" aria-describedby="phoneHelp" 
				placeholder="Enter phone" v-model="phone"
				v-bind:class="{'is-invalid':error && error.phone}"/>
			<div class="invalid-feedback">
				{{error && error.phone}}
	    </div>
		</div>
		<div class="text-right">
			<button class="btn btn-primary">SUBMIT</button>
		</div>
	</form>
	

</div>
</template>

<style>

.button-label{line-height:31px;}
.font-sm{font-size:0.8em;}
</style>

<script>

const categories = [
	'entitlement','feasibility','financing','geotechnical','permitting','planning','structural engineering','surveying','utility','other']

export default {
	name:'parcel-service-provider',
	data:()=>{
		return {
			categories
		}
	},
	props: {
		category:{
			type:String,
		},
		parcel:{
			type:Object
		},
		addressId:{}
	},
	computed: {
	},
	data:function(){
		return {error:{}}
	},
	methods:{
		routeService:function(category){
			this.$router.push({
				name:'parcel-service',
				params:{
					id:this.parcel.id,
					category
				},
				query:{
					addressId:this.addressId
				}
			});
		},
		routeBack:function(){
			this.$router.push({
				name:'parcels-tab',
				params:{
					id:this.parcel.id,
					tab:'services'
				},
				query:{
					addressId:this.addressId
				}
			});
		}
	}
}

</script>




// WEBPACK FOOTER //
// src/components/parcel/parcel-service-provider.vue